export class ChangePassword {
    emailAddr: string;
    oldPassword: string;
    newPassword: string;
    verifyPassword: string;
    resetCode: string;
    captcha?: string;
}
